export default __webpack_public_path__ + "static/media/herderinnekopje30.jpg";